/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  IBankAccountProps,
  IGeneralTableIdentifierException,
  IInventoryAdjustmentActiveLocations,
  InventoryAdjustment,
  InventoryAdjustmentItems,
  InventoryAdjustmentState,
  IPostingPeriod,
} from 'commons/types';

const initialState: InventoryAdjustmentState = {
  inventoryAdjustmentList: [],
  selectedInventoryAdjustment: null,
  postingPeriods: [],
  bankAccounts: [],
  activeLocations: [],
  itemListTableError: [],
};

const inventoryAdjustmentSlice = createSlice({
  name: 'inventoryAdjustment',
  initialState,
  reducers: {
    setAllInventoryAdjustments(
      state: InventoryAdjustmentState,
      action: { type: string; payload: InventoryAdjustment[] },
    ) {
      state.inventoryAdjustmentList = action.payload;
    },
    setSelectedInventoryAdjustment(
      state: InventoryAdjustmentState,
      action: { type: string; payload: InventoryAdjustment | null },
    ) {
      state.selectedInventoryAdjustment = action.payload;
    },
    updateSelectedInventoryAdjustmentItem(
      state: InventoryAdjustmentState,
      action: { payload: InventoryAdjustmentItems[] },
    ) {
      if (state.selectedInventoryAdjustment) {
        state.selectedInventoryAdjustment = {
          ...state.selectedInventoryAdjustment,
          items: action.payload,
        };
      }
    },
    setPostingPeriods(
      state: InventoryAdjustmentState,
      action: { payload: IPostingPeriod[] },
    ) {
      state.postingPeriods = action.payload;
    },
    setBankAccounts(
      state: InventoryAdjustmentState,
      action: { payload: IBankAccountProps[] },
    ) {
      state.bankAccounts = action.payload;
    },
    setIAActiveLocations(
      state: InventoryAdjustmentState,
      action: { payload: IInventoryAdjustmentActiveLocations[] },
    ) {
      state.activeLocations = action.payload;
    },
    setIAItemListTableError(
      state: InventoryAdjustmentState,
      action: { payload: IGeneralTableIdentifierException[] },
    ) {
      state.itemListTableError = action.payload;
    },
  },
});

export const {
  setAllInventoryAdjustments,
  setSelectedInventoryAdjustment,
  updateSelectedInventoryAdjustmentItem,
  setPostingPeriods,
  setBankAccounts,
  setIAActiveLocations,
  setIAItemListTableError,
} = inventoryAdjustmentSlice.actions;

export default inventoryAdjustmentSlice.reducer;
